import React from 'react';

import { Box, Stack } from '@mui/material';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AccountDropdown from './AccountDropdown';
import LoggedUser from './LoggedUser';
import NavItem from '../NavItem';
import { publicNavItems } from '../../../../lib/constants/nav-menu-data';
import { useIsAuthenticated } from '@azure/msal-react';
import { useScreenSmallerThan } from '../../../../lib/hooks/breakpoint-hooks';

const AccountItem = () => {
    const isAuthenticated = useIsAuthenticated();
    const isSmallerThanMedium = useScreenSmallerThan('md');

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            {isAuthenticated ? (
                <Box sx={{ position: 'relative' }}>
                    <Stack
                        onClick={handleClick}
                        direction={'row'}
                        alignItems={'center'}
                        gap={0.5}
                        sx={{ ':hover': { cursor: 'pointer' } }}>
                        <LoggedUser />
                        <ArrowDropDownIcon sx={{ color: (t) => t.palette.primary.main }} />
                    </Stack>
                    <AccountDropdown
                        anchorEl={anchorEl}
                        onClick={handleClose}
                        onClose={handleClose}
                        open={open}
                    />
                </Box>
            ) : (
                <>
                    {!isSmallerThanMedium && (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 1
                            }}>
                            {publicNavItems.map((item) => (
                                <NavItem key={item.label} item={item} />
                            ))}
                        </Box>
                    )}
                </>
            )}
        </React.Fragment>
    );
};

export default AccountItem;
